let applyButtonClicked = false;

function getGridSetting(key) {
  const scriptTag = document.getElementById("collection-grid-settings");
  if (scriptTag) {
    try {
      const parsed = JSON.parse(scriptTag.textContent);
      if (typeof parsed[key] !== "undefined") {
        return Boolean(parsed[key]);
      }
    } catch (e) {}
  }
  const grid =
    document.getElementById("product-grid") ||
    document.getElementById("ProductGridContainer");
  if (grid) {
    if (grid.dataset && typeof grid.dataset[key] !== "undefined") {
      return grid.dataset[key] === "true";
    }
    try {
      const raw = grid.getAttribute("data-section-settings");
      if (raw) {
        const parsed = JSON.parse(raw);
        if (typeof parsed[key] !== "undefined") {
          return Boolean(parsed[key]);
        }
      }
    } catch (e) {}
  }
  return false;
}

function applyInitialCollectionUrlSettings() {
  const grid =
    document.getElementById("product-grid") ||
    document.getElementById("ProductGridContainer");
  if (!grid || window.location.pathname.includes("/search")) return;

  const shouldFilterAvailability = getGridSetting("autoFilterAvailability");
  const shouldAppendDefaultSort = getGridSetting("autoAppendDefaultSort");

  const urlObj = new URL(window.location.href);
  let changed = false;

  if (shouldFilterAvailability && !urlObj.searchParams.has("filter.v.availability")) {
    urlObj.searchParams.set("filter.v.availability", "1");
    changed = true;
  }

  if (shouldAppendDefaultSort && !urlObj.searchParams.has("sort_by")) {
    const defaultSortEl = document.querySelector("[data-default-sort]");
    const defaultSort =
      defaultSortEl?.dataset?.defaultSort || "manual";
    urlObj.searchParams.set("sort_by", defaultSort);
    changed = true;
  }

  if (changed) {
    window.history.replaceState({}, "", urlObj.toString());
  }

  // Update sort option UI to match active sort
  const activeSort =
    urlObj.searchParams.get("sort_by") ||
    document.querySelector("[data-default-sort]")?.dataset?.defaultSort ||
    "manual";
  document.querySelectorAll("li[data-sort-value]").forEach((sortOption) => {
    sortOption.classList.toggle(
      "selected-sort-option",
      sortOption.dataset.sortValue === activeSort
    );
  });
}
/**
 *  @class
 *  @function FacetsToggle
 */
class FacetsToggle {
  constructor() {
    this.container = document.getElementById("Facet-Drawer");
    let button = document.getElementById("Facets-Toggle");

    // Add functionality to buttons
    if (button) {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        document.getElementsByTagName("body")[0].classList.toggle("open-cc");
        this.container.classList.toggle("active");
      });
    }
    setTimeout(function () {
      window.dispatchEvent(new Event("resize.resize-select"));
    }, 10);
  }
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector("form")?.addEventListener(
      "input",
      this.debouncedOnSubmit.bind(this)
    );
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    const isSearchPage = window.location.pathname.includes("/search");
    try {
      if (isSearchPage) {
        showLoader();
      }

      FacetFiltersForm.searchParamsPrev = searchParams;
      const sections = FacetFiltersForm.getSections();
      const container = document.getElementsByClassName("thb-filter-count");
      const productGridContainer = document.getElementById(
        "ProductGridContainer"
      );
      const collection = productGridContainer.querySelector(".collection");

      // Store both mobile form states before any DOM updates
      const mobileFormsState = {
        filterFormActive:
          productGridContainer
            .querySelector(".facets-mobile-filter-form")
            ?.classList.contains("active") || false,
        mobileFormActive:
          productGridContainer
            .querySelector(".facets-mobile-form")
            ?.classList.contains("active") || false,
      };

      collection.classList.add("loading");

      for (const item of container) {
        item.classList.add("loading");
      }

      const executeSections = () => {

        FacetFiltersForm.updateURLHash(searchParams)
        const currentUrlParams = new URLSearchParams(window.location.search);
        const currentSortByUrl = currentUrlParams.get("sort_by");

        // console.log("searchParams", searchParams);
        
        sections.forEach((section) => {
          let url = "";
          if (isSearchPage) {
            url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
          } else {
            url = `${window.location.pathname}?section_id=${section.section}&${searchParams}${currentSortByUrl ? `&sort_by=${currentSortByUrl}` : ""}`;
          }

          // console.log("redner url", url);
          

          const filterDataUrl = (element) => element.url === url;

          if (FacetFiltersForm.filterData.some(filterDataUrl)) {

            FacetFiltersForm.renderSectionFromCache(
              filterDataUrl,
              event,
              mobileFormsState
            );
          } else {

            FacetFiltersForm.renderSectionFromFetch(
              url,
              event,
              mobileFormsState
            );
          }
        });

        collection.classList.remove("loading");
        for (const item of container) {
          item.classList.remove("loading");
        }
        if (updateURLHash) {
          FacetFiltersForm.updateURLHash(searchParams);
        }

        window.dispatchEvent(
          new CustomEvent("facet-filters-updated", {
            detail: { searchParams },
          })
        );
      };

      if (isSearchPage) {
        const promises = sections.map((section) => {
          const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
          const filterDataUrl = (element) => element.url === url;

          if (FacetFiltersForm.filterData.some(filterDataUrl)) {
            return FacetFiltersForm.renderSectionFromCache(
              filterDataUrl,
              event,
              mobileFormsState
            );
          } else {
            return FacetFiltersForm.renderSectionFromFetch(
              url,
              event,
              mobileFormsState
            );
          }
        });

        Promise.all(promises)
          .then(() => {
            executeSections();
            if (isSearchPage) {
              setTimeout(() => {
                hideLoader();
              }, 1000);
            }
          })
          .catch((error) => {
            console.error(error);
            if (isSearchPage) {
              hideLoader();
            }
          });
      } else {
        executeSections();
      }
    } catch (error) {
      console.error(error);
      if (isSearchPage) {
        hideLoader();
      }
    }
  }

  static renderSectionFromFetch(url, event, mobileFormsState) {
  fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      const html = responseText;
      FacetFiltersForm.filterData = [
        ...FacetFiltersForm.filterData,
        {
          html,
          url,
        },
      ];

      // console.log(url, "url");

      // Create a temporary container to parse the HTML
      const tempContainer = document.createElement("div");
      tempContainer.innerHTML = html;

      // Preserve active states for both forms
      if (mobileFormsState.filterFormActive) {
        const filterForm = tempContainer.querySelector(
          ".facets-mobile-filter-form"
        );
        if (filterForm) {
          filterForm.classList.add("active");
        }
      }

      if (mobileFormsState.mobileFormActive) {
        const mobileForm = tempContainer.querySelector(".facets-mobile-form");
        if (mobileForm) {
          mobileForm.classList.add("active");
        }
      }

      // Extract final modified HTML and update the DOM
      const modifiedHtml = tempContainer.innerHTML;
      FacetFiltersForm.renderFilters(modifiedHtml, event);
      FacetFiltersForm.renderProductGridContainer(modifiedHtml);
      FacetFiltersForm.renderProductCount(modifiedHtml);
      new FacetsToggle();

      // Restore the active tab AFTER the DOM has been replaced.
      // executeSections() (which fires facet-filters-updated) runs BEFORE this
      // fetch resolves on collection pages, so we must re-apply here explicitly.
      const savedTabName = sessionStorage.getItem('active_filter_tab_name');
      const tabbedContainer = document.getElementById('TabbedFilterContainer');
      if (tabbedContainer && savedTabName) {
        const allTabs  = tabbedContainer.querySelectorAll('.tabbed-filter__tab-item');
        const allPanes = tabbedContainer.querySelectorAll('.tabbed-filter__pane');
        let targetTab  = null;
        allTabs.forEach((t) => { if (t.getAttribute('data-tab-name') === savedTabName) targetTab = t; });
        if (!targetTab && allTabs.length > 0) targetTab = allTabs[0];
        if (targetTab) {
          const idx = targetTab.getAttribute('data-tab-index');
          allTabs.forEach((t)  => t.classList.toggle('active', t === targetTab));
          allPanes.forEach((p) => p.classList.toggle('active', p.getAttribute('data-pane-index') === idx));
        }
      }
    })
    .catch((error) => {
      console.error("Error fetching section HTML:", error);
    });
}

  static renderSectionFromCache(filterDataUrl, event, mobileFilterState) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;

    // Create a temporary container to parse the HTML
    const tempContainer = document.createElement("div");
    tempContainer.innerHTML = html;

    // If mobile filter was active, ensure it stays active in the new HTML
    if (mobileFilterState.isActive) {
      const mobileFilterForm = tempContainer.querySelector(
        ".facets-mobile-filter-form"
      );
      if (mobileFilterForm) {
        mobileFilterForm.classList.add("active");
      }
    }

    // Update the HTML with our modified version
    const modifiedHtml = tempContainer.innerHTML;

    FacetFiltersForm.renderFilters(modifiedHtml, event);
    FacetFiltersForm.renderProductGridContainer(modifiedHtml);
    FacetFiltersForm.renderProductCount(modifiedHtml);
    new FacetsToggle();

    // Restore the active tab AFTER the DOM has been replaced.
    const savedTabName = sessionStorage.getItem('active_filter_tab_name');
    const tabbedContainer = document.getElementById('TabbedFilterContainer');
    if (tabbedContainer && savedTabName) {
      const allTabs  = tabbedContainer.querySelectorAll('.tabbed-filter__tab-item');
      const allPanes = tabbedContainer.querySelectorAll('.tabbed-filter__pane');
      let targetTab  = null;
      allTabs.forEach((t) => { if (t.getAttribute('data-tab-name') === savedTabName) targetTab = t; });
      if (!targetTab && allTabs.length > 0) targetTab = allTabs[0];
      if (targetTab) {
        const idx = targetTab.getAttribute('data-tab-index');
        allTabs.forEach((t)  => t.classList.toggle('active', t === targetTab));
        allPanes.forEach((p) => p.classList.toggle('active', p.getAttribute('data-pane-index') === idx));
      }
    }
  }

  static renderProductGridContainer(html) {
    const productGridContainer = document.getElementById("ProductGridContainer");
    const facetDrawer = productGridContainer.querySelector("#Facet-Drawer");

    const tempContainer = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer");

    if (tempContainer) {
      const newFacetDrawer = tempContainer.querySelector("#Facet-Drawer");

      if (facetDrawer && facetDrawer.classList.contains("active")) {
        newFacetDrawer.classList.add("active");
      }

      productGridContainer.innerHTML = "";
      Array.from(tempContainer.children).forEach((child) => {
        productGridContainer.appendChild(child);
        // HulkappWishlist.init(); // if needed
      });
    }

    // ✅ Inventory Sorting
    const urlParams = new URLSearchParams(window.location.search);
    const sortBy = urlParams.get("sort_by");
    const grid = productGridContainer.querySelector("#product-grid"); // adjust this selector if needed
    const enableInventorySorting = grid.dataset.inventorySort;


    if (enableInventorySorting === 'true') {
      if (sortBy !== "price-ascending" && sortBy !== "price-descending") {
        if (grid) {
          const items = Array.from(grid.querySelectorAll("li"));

          items.sort((a, b) => {
            const inventoryA = parseInt(a.dataset.inventory, 10) || 0;
            const inventoryB = parseInt(b.dataset.inventory, 10) || 0;
            return inventoryB - inventoryA; // highest to lowest
          });

          items.forEach((item) => grid.appendChild(item));
        }
      }
    }

    // Search page specific logic
    if (window.location.href.includes("/search")) {
      let parsedHTML = new DOMParser().parseFromString(html, "text/html");
      InitialMobileLoadFilters(parsedHTML, true);
      initialApplyButtonClickHandler(parsedHTML, true);
    }


    // code for facets searchbox
    const searchInputs = document.querySelectorAll('.searchInput');

    searchInputs.forEach((input) => {
      const container = input.closest('.search-block');
      const listItems = container.querySelectorAll('.facet-filter-ul li');

      input.addEventListener('input', function (e) {
        e.stopPropagation();
        const query = this.value.toLowerCase();

        listItems.forEach((item) => {
          const text = item.textContent.toLowerCase();
          item.style.display = text.includes(query) ? 'flex' : 'none';
        });

        const noResultsText = container.querySelector('.no-results-text');

        if (listItems && noResultsText) {
          const allHidden = Array.from(listItems).every(item => item.style.display === 'none');

          if (allHidden) {
            noResultsText.classList.remove('hidden');
          } else {
            noResultsText.classList.add('hidden');
          }
        }
      });
    });

    const searchIconWrappers = document.querySelectorAll('.search-icon-wrapper');


    // for desktop only
    searchIconWrappers.forEach((searchIconWrapper) => {
      const iconSearch = searchIconWrapper.querySelector('.icon-search');
      const iconClose = searchIconWrapper.querySelector('.icon-close');
      const inputBox = searchIconWrapper.closest('.searchbar-main-wrapper')?.querySelector('input.facets-filter-searchbox');
      const filterTitle = searchIconWrapper.closest('details')?.querySelector('summary .filter-title-div');

      if (!iconSearch || !iconClose || !inputBox || !filterTitle) return;

      iconSearch.addEventListener('click', () => {
        iconSearch.classList.add('hidden');
        iconClose.classList.remove('hidden');
        inputBox.classList.remove('hidden');
        filterTitle.classList.add('hidden');
        inputBox.focus();
      });

      iconClose.addEventListener('click', () => {
        iconSearch.classList.remove('hidden');
        iconClose.classList.add('hidden');
        inputBox.classList.add('hidden');
        filterTitle.classList.remove('hidden');
        inputBox.value = '';

        // Show all list items
        const container = inputBox.closest('.search-block');
        const listItems = container?.querySelectorAll('.facet-filter-ul li');
        const noResultsText = container.querySelector('.no-results-text');

        if (listItems) {
          listItems.forEach((item) => {
            item.style.display = 'flex';
            if (!noResultsText.classList.contains('hidden')) {
              noResultsText.classList.add('hidden');
            }
          });
        }
      });
    })

    // ✅ Re-initialize the product fetcher after HTML is updated
    const newFetcher = new CollectionProductsFetcher();
    window.collectionProductsFetcher = newFetcher;

    newFetcher.fetchAllProducts().then((products) => {
      newFetcher.setupObserver(() => {
        newFetcher.renderNextProducts(products);
      });
      newFetcher.renderInitialProducts(products);
    });
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount");
    const container = document.getElementsByClassName("thb-filter-count");
    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove("loading");
      }
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row"
    );

    const matchesIndex = (element) => {
      const jsFilter = event
        ? event.target.closest("collapsible-row")
        : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    );

    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(
        `collapsible-row[data-index="${element.dataset.index}"]`
      ).innerHTML = element.innerHTML;
    });
    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    new FacetsToggle();

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest("collapsible-row")
      );
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [".active-facets"];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [".mobile-filter-count"];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    const sourceElement = document.querySelectorAll(".mobile-filter-list");
    const targetElement = html.querySelectorAll(".mobile-filter-list");

    if (sourceElement.length === targetElement.length) {
      sourceElement.forEach((sourceElement, index) => {
        const targetEle = targetElement[index];
        if (targetEle) {
          sourceElement.innerHTML = targetEle.innerHTML;
        }
      });
    }
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML =
        source.querySelector(".facets__selected").outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    if (!(searchParams instanceof URLSearchParams)) {
      searchParams = new URLSearchParams(searchParams);
    }

    // Handle price range filters
    if (searchParams.get("filter.v.price.gte") === "0.00") {
      searchParams.delete("filter.v.price.gte");
    }

    const priceSlider = document.querySelector(".price_slider");
    if (priceSlider) {
      const maxPrice = parseFloat(priceSlider.dataset.max).toFixed(2);
      if (searchParams.get("filter.v.price.lte") === maxPrice) {
        searchParams.delete("filter.v.price.lte");
      }
    }

    // Handle default sorting UI
    const currentSortValue = searchParams.get("sort_by");
    const defaultSortElement = document.querySelector("[data-default-sort]");
    const shouldAppendDefaultSort = getGridSetting("autoAppendDefaultSort");

    if (defaultSortElement?.dataset?.defaultSort) {
      const activeSort = currentSortValue || defaultSortElement.dataset.defaultSort;
      if (shouldAppendDefaultSort && !currentSortValue) {
        searchParams.set("sort_by", defaultSortElement.dataset.defaultSort);
      }
      // Update sort option UI
      document.querySelectorAll("li[data-sort-value]").forEach((sortOption) => {
        sortOption.classList.toggle(
          "selected-sort-option",
          sortOption.dataset.sortValue === activeSort
        );
      });
    }

    // Availability filter toggle
    const shouldFilterAvailability = getGridSetting("autoFilterAvailability");
    if (
      shouldFilterAvailability &&
      !searchParams.has("filter.v.availability") &&
      !window.location.pathname.includes("/search")
    ) {
      searchParams.append("filter.v.availability", "1");
    }

    // Preserve non-filter/sort params (e.g. UTM params) from the original URL
    FacetFiltersForm.preserveExtraParams(searchParams);

    const searchParamsString = searchParams.toString();

    // Update browser's history with the modified URL
    history.pushState(
      { searchParams: searchParamsString },
      "",
      `${window.location.pathname}${searchParamsString ? `?${searchParamsString}` : ""
      }`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const currentUrlParams = new URLSearchParams(window.location.search);
    const formData = new FormData(event.target.closest("form"));
    const searchParams = new URLSearchParams(formData);
    // Handle price range: Remove `gte` or `lte` if they match default values
    if (searchParams.get("filter.v.price.gte") === "0.00") {
      searchParams.delete("filter.v.price.gte");
    }

    if (document.querySelector(".price_slider")) {
      const maxPrice = parseFloat(
        document.querySelector(".price_slider").dataset.max
      ).toFixed(2);
      if (searchParams.get("filter.v.price.lte") === maxPrice) {
        searchParams.delete("filter.v.price.lte");
      }
    }

    // Handle sorting: Retain the currently selected sort option
    const sortOptions = document.querySelectorAll(".sort-option");
    let sortByFound = false;

    sortOptions.forEach((option) => {
      if (option.checked) {
        sortByFound = true;
        searchParams.set("sort_by", option.value);
      }
    });

    // If no sort option is explicitly selected, ensure it uses the current sort_by from the URL
    if (!sortByFound) {
      const currentSortBy = currentUrlParams.get("sort_by");
      if (currentSortBy) {
        searchParams.set("sort_by", currentSortBy);
      }
    }

    // Preserve non-filter/sort params (e.g. UTM params) from the original URL
    FacetFiltersForm.preserveExtraParams(searchParams);

    // If availability filter toggle is active, ensure it's appended if missing
    const shouldFilterAvailability = getGridSetting("autoFilterAvailability");
    if (
      shouldFilterAvailability &&
      !searchParams.has("filter.v.availability") &&
      !window.location.pathname.includes("/search")
    ) {
      searchParams.append("filter.v.availability", "1");
    }

    // Render the updated page
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    let url = event.currentTarget.href;
    const queryString = url.includes("?")
      ? url.slice(url.indexOf("?") + 1)
      : "";
    const shouldFilterAvailability = getGridSetting("autoFilterAvailability");
    if (
      shouldFilterAvailability &&
      !queryString.includes("filter.v.availability=1") &&
      window.location.href.includes("/collections")
    ) {
      url = queryString + (queryString ? "&" : "") + "filter.v.availability=1";
    } else {
      url = queryString;
    }

    FacetFiltersForm.renderPage(url);
  }

  /**
   * Preserve non-filter/sort query params (e.g. utm_source, utm_medium, etc.)
   * by reading them from the original URL and appending to searchParams.
   */
  static preserveExtraParams(searchParams) {
    if (!(searchParams instanceof URLSearchParams)) return;
    const originalParams = new URLSearchParams(window.location.search);
    originalParams.forEach((value, key) => {
      // Skip keys already handled by facets/sorting
      if (
        key.startsWith('filter.') ||
        key === 'sort_by' ||
        key === 'page' ||
        key === 'section_id' ||
        key === 'q'
      ) return;
      // Only add if not already present
      if (!searchParams.has(key)) {
        searchParams.set(key, value);
      }
    });
  }

  static updateURL(newParams) {
    const newURL = `${window.location.pathname}?${newParams}`;
    history.pushState({ searchParams: newParams }, "", newURL);
    this.previousURL = newURL;
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("a").forEach((item) => {
      item.addEventListener("click", (event) => {
        event.preventDefault();
        const form =
          this.closest("facet-filters-form") ||
          document.querySelector("facet-filters-form");
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define("facet-remove", FacetRemove);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    let slider = this.querySelector(".price_slider"),
      amounts = this.querySelector(".price_slider_amount"),
      args = {
        start: [
          parseFloat(slider.dataset.minValue || 0),
          parseFloat(slider.dataset.maxValue || slider.dataset.max),
        ],
        connect: true,
        step: 10,
        direction: document.dir,
        range: {
          min: 0,
          max: parseFloat(slider.dataset.max),
        },
      },
      event = new CustomEvent("input"),
      form =
        this.closest("facet-filters-form") ||
        document.querySelector("facet-filters-form");

    if (slider.classList.contains("noUi-target")) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on("update", function (values) {
      amounts.querySelector(".field__input_min").value = values[0];
      amounts.querySelector(".field__input_max").value = values[1];
    });
    slider.noUiSlider.on("change", function (values) {
      form.querySelector("form").dispatchEvent(event);
    });
  }
}
customElements.define("price-slider", PriceSlider);

function showLoader() {
  const body = document.querySelector("body");
  const wrapper = document.createElement("div");
  wrapper.classList.add("loader-wrapper");
  wrapper.classList.add("filters-loader");
  body.appendChild(wrapper);
}

function hideLoader() {
  const wrapper = document.querySelector(".loader-wrapper");
  wrapper.remove();
}

document.addEventListener("DOMContentLoaded", () => {
  const hasFilterParams = () => {
    return window.location.search.indexOf('filter.') !== -1;
  };
  if (!hasFilterParams()) {
    sessionStorage.removeItem('active_filter_tab_name');
  }
  new FacetsToggle();

  const updateMaterialChipState = () => {
    document.querySelectorAll('.material-filter-bar').forEach((materialBar) => {
      const filterParam = materialBar.dataset.filterParam;
      if (!filterParam) return;

      const currentParams = new URLSearchParams(window.location.search);
      const activeValues = new Set(currentParams.getAll(filterParam));

      materialBar.querySelectorAll('.material-chip').forEach((chip) => {
        const isActive = activeValues.has(chip.dataset.filterValue);
        chip.classList.toggle('active', isActive);
        chip.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    });
  };

  // ─── TAB SWITCHER (event delegation) ────────────────────────────────────────
  // Registered once on document — works forever even after AJAX replaces the DOM
  document.addEventListener('click', (e) => {
    const tabItem = e.target.closest('.tabbed-filter__tab-item');
    if (!tabItem) return;
    const container = document.getElementById('TabbedFilterContainer');
    if (!container) return;
    e.preventDefault();
    const tabName  = tabItem.getAttribute('data-tab-name');
    const tabIndex = tabItem.getAttribute('data-tab-index');
    sessionStorage.setItem('active_filter_tab_name', tabName);
    container.querySelectorAll('.tabbed-filter__tab-item').forEach((t) => {
      t.classList.toggle('active', t === tabItem);
    });
    container.querySelectorAll('.tabbed-filter__pane').forEach((p) => {
      p.classList.toggle('active', p.getAttribute('data-pane-index') === tabIndex);
    });
  });

  // Restore saved tab & rebuild show-more buttons after every AJAX re-render
  const restoreActiveTab = () => {
    const container = document.getElementById('TabbedFilterContainer');
    if (!container) return;
    const savedTabName = sessionStorage.getItem('active_filter_tab_name');
    const tabs  = container.querySelectorAll('.tabbed-filter__tab-item');
    const panes = container.querySelectorAll('.tabbed-filter__pane');
    let targetTab = null;
    if (savedTabName) {
      tabs.forEach((t) => { if (t.getAttribute('data-tab-name') === savedTabName) targetTab = t; });
    }
    if (!targetTab && tabs.length > 0) targetTab = tabs[0];
    if (!targetTab) return;
    const targetIndex = targetTab.getAttribute('data-tab-index');
    tabs.forEach((t) =>  t.classList.toggle('active', t === targetTab));
    panes.forEach((p) => p.classList.toggle('active', p.getAttribute('data-pane-index') === targetIndex));
  };

  const setupShowMore = () => {
    const container = document.getElementById('TabbedFilterContainer');
    if (!container) return;
    container.querySelectorAll('.tabbed-filter__pane').forEach((pane) => {
      pane.querySelectorAll('.tabbed-filter__show-more-btn').forEach((b) => b.remove());
      const chips   = pane.querySelectorAll('.material-chip');
      const isMobile = window.innerWidth < 768;
      const limit    = isMobile ? 5 : 17;
      if (chips.length <= limit) {
        chips.forEach((c) => (c.style.display = ''));
        return;
      }
      let hidden = 0;
      chips.forEach((chip, idx) => {
        if (idx >= limit && !chip.classList.contains('active')) {
          chip.style.display = 'none';
          hidden++;
        } else {
          chip.style.display = '';
        }
      });
      if (hidden > 0) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'tabbed-filter__show-more-btn';
        btn.textContent = `+${hidden} MORE`;
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          if (window.innerWidth < 768) {
            const mob = document.querySelector('.facets-mobile-filter-form');
            if (mob) { mob.classList.add('active'); document.body.classList.add('no-scroll'); }
          } else {
            const drawer = document.getElementById('Facet-Drawer');
            const toggle = document.getElementById('Facets-Toggle');
            if (drawer) { document.body.classList.add('open-cc'); drawer.classList.add('active'); }
            else if (toggle) { toggle.click(); }
          }
        });
        pane.querySelector('.tabbed-filter__chips').appendChild(btn);
      }
    });
  };

  // ─── CHIP CLICK HANDLER ─────────────────────────────────────────────────────
  const handleMaterialChipClick = (event) => {
    const chip = event.target.closest('.material-chip');
    if (!chip) return;
    const materialBar = chip.closest('.material-filter-bar');
    if (!materialBar) return;
    const filterParam = materialBar.dataset.filterParam;
    if (!filterParam) return;
    event.preventDefault();
    // Persist the currently active tab BEFORE AJAX replaces the DOM
    const activeTabEl = document.querySelector('#TabbedFilterContainer .tabbed-filter__tab-item.active');
    if (activeTabEl) sessionStorage.setItem('active_filter_tab_name', activeTabEl.getAttribute('data-tab-name'));
    const params = new URL(window.location.href).searchParams;
    const filterValue    = chip.dataset.filterValue;
    const selectedValues = params.getAll(filterParam);
    const isActive       = selectedValues.includes(filterValue);
    params.delete(filterParam);
    (isActive ? selectedValues.filter((v) => v !== filterValue) : [...selectedValues, filterValue])
      .forEach((v) => params.append(filterParam, v));
    params.delete('page');
    params.delete('section_id');
    const shouldFilterAvailability = getGridSetting("autoFilterAvailability");
    if (shouldFilterAvailability && !params.has('filter.v.availability') && !window.location.href.includes('/search')) {
      params.set('filter.v.availability', '1');
    }
    const searchParamsString = params.toString();
    const nextUrl = `${window.location.pathname}${searchParamsString ? '?' + searchParamsString : ''}`;
    if (typeof FacetFiltersForm !== 'undefined' && typeof FacetFiltersForm.renderPage === 'function') {
      FacetFiltersForm.renderPage(searchParamsString, null, true);
    } else {
      window.location.href = nextUrl;
    }
    window.setTimeout(updateMaterialChipState, 50);
  };

  document.addEventListener('click', handleMaterialChipClick);

  const onFiltersUpdated = () => {
    updateMaterialChipState();
    restoreActiveTab();
    setupShowMore();
  };

  window.addEventListener('facet-filters-updated', onFiltersUpdated);
  window.addEventListener('popstate',  onFiltersUpdated);
  window.addEventListener('pageshow',  onFiltersUpdated);

  // Initial run
  updateMaterialChipState();
  restoreActiveTab();
  setupShowMore();
});

class CustomSortByFilter extends HTMLElement {
  constructor() {
    super();
    this.initializeVariables();
    this.initialLoad();
  }

  initialLoad() {
    applyInitialCollectionUrlSettings();
  }

  initializeVariables() {
    this.querySelectorAll("li").forEach((sortByListItem) => {
      sortByListItem.addEventListener("click", this.handleSort.bind(this));
    });
  }

  updateURL(url, sortValue) {
    const urlObj = new URL(url);
    urlObj.searchParams.set("sort_by", sortValue);
    return urlObj.toString();
  }

  handleSort(event) {
    const sortValue = event.currentTarget.dataset.sortValue;

    // Remove the active class from all list items
    this.querySelectorAll("li").forEach((sortByListItem) =>
      sortByListItem.classList.remove("selected-sort-option")
    );

    // Add the active class to the clicked item
    event.currentTarget.classList.add("selected-sort-option");

    // Update the URL with the new sort value
    const updatedUrl = this.updateURL(window.location.href, sortValue);
    const urlObj = new URL(updatedUrl);
    const searchParams = urlObj.searchParams;
    closePopupSortFilter(".facets-mobile-form");
    // Render the page with new sort parameters
    FacetFiltersForm.renderPage(searchParams);
  }

  updateActiveSortOption(activeSortValue) {
    this.querySelectorAll("li").forEach((sortByListItem) => {
      sortByListItem.classList.remove("selected-sort-option");
    });
    const activeSortOption = this.querySelector(
      `li[data-sort-value="${activeSortValue}"]`
    );
    if (activeSortOption) {
      activeSortOption.classList.add("selected-sort-option");
    }
    closePopupSortFilter(".facets-mobile-form");
  }
}
customElements.define("custom-sort-by-filter", CustomSortByFilter);

// Mobile Sort and Filter
document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("click", (event) => {
    const target = event.target;

    if (target.closest(".sort")) {
      showPopup(".facets-mobile-form");
    } else if (target.closest(".filter")) {
      showPopup(".facets-mobile-filter-form");
    } else if (target.closest(".close-icon")) {
      closePopupSortFilter(".facets-mobile-form");
      closePopupSortFilter(".facets-mobile-filter-form");
    } else if (target.closest(".mobile-filters-apply-button")) {
      closePopupSortFilter(".facets-mobile-filter-form");
    }
  });

  InitialMobileLoadFilters(document);
  initialApplyButtonClickHandler(document);
});

function showPopup(selector) {
  const popupContainer = document.querySelector(selector);
  if (popupContainer) {
    popupContainer.classList.add("active");
    document.body.classList.add("no-scroll");
  }
}

function closePopupSortFilter(selector) {
  const popupContainer = document.querySelector(selector);
  if (popupContainer) {
    popupContainer.classList.remove("active");
    document.body.classList.remove("no-scroll");
  }
}

let globalActiveFilterIndexApply = 0;
function initialApplyButtonClickHandler(html) {
  html.addEventListener("click", (event) => {
    if (event.target.closest(".mobile-filters-apply-button")) {
      closePopupSortFilter(".facets-mobile-filter-form");
      applyButtonClicked = true;
    }
  });
}

// This function is used to update the mobile filters in search page when section rendering happens and also for the first render.
// Store the active index
let globalActiveFilterIndex = 0;
function InitialMobileLoadFilters(html, isRerenderedHTML = false) {
  // Select parsed HTML elements
  const filterLabels = html.querySelectorAll(".mobile-filter-title");
  const filterLists = html.querySelectorAll(".mobile-filter-content");

  if (filterLabels.length === 0 || filterLists.length === 0) {
    return;
  }

  if (isRerenderedHTML) {
    // Replace current document elements with the parsed HTML elements
    const documentLabels = document.querySelectorAll(".mobile-filter-title");
    const documentLists = document.querySelectorAll(".mobile-filter-content");

    filterLabels.forEach((label, index) => {
      if (documentLabels[index]) {
        documentLabels[index].replaceWith(label);
      }
    });

    filterLists.forEach((list, index) => {
      if (documentLists[index]) {
        documentLists[index].replaceWith(list);
      }
    });
  }

  // Re-select the updated elements from the document
  const updatedFilterLabels = document.querySelectorAll(".mobile-filter-title");
  const updatedFilterLists = document.querySelectorAll(
    ".mobile-filter-content"
  );

  // Set the active filter based on the global index
  if (updatedFilterLists.length > 0) {
    // Remove any existing active classes first
    updatedFilterLists.forEach((list) => list.classList.remove("active"));
    updatedFilterLabels.forEach((label) =>
      label.classList.remove("filter-facets-active")
    );

    // Apply active classes to the correct filter
    if (globalActiveFilterIndex < updatedFilterLists.length) {
      updatedFilterLists[globalActiveFilterIndex].classList.add("active");
      updatedFilterLabels[globalActiveFilterIndex].classList.add(
        "filter-facets-active"
      );
    } else {
      // Fallback to first filter if stored index is out of bounds
      globalActiveFilterIndex = 0;
      updatedFilterLists[0].classList.add("active");
      updatedFilterLabels[0].classList.add("filter-facets-active");
    }
  }

  // Add event listeners to the updated elements
  updatedFilterLabels.forEach((label, index) => {
    label.addEventListener("click", function (e) {
      e.preventDefault();
      // Update the global active index when clicked   
      globalActiveFilterIndex = index;

      // Remove active classes
      updatedFilterLists.forEach((list) => list.classList.remove("active"));
      updatedFilterLabels.forEach((item) =>
        item.classList.remove("filter-facets-active")
      );

      // Add new active classes
      updatedFilterLists[index].classList.add("active");
      label.classList.add("filter-facets-active");

      const allInputs = document.querySelectorAll('input.facets-filter-searchbox');
      allInputs.forEach((input) => {
        if (input.value !== '') {
          input.value = '';
        }

      // Show all list items
      const container = input.closest('.search-block');
      const listItems = container?.querySelectorAll('.facet-filter-ul li');
      const noResultsText = container.querySelector('.no-results-text');


      if (listItems) {
        listItems.forEach((item) => {
          item.style.display = 'flex';
          if (!noResultsText.classList.contains('hidden')) {
            noResultsText.classList.add('hidden');
          }
        });
      }
      })
    });
  });
}

// code for tag filter
// -------------------------
class customTagFilter extends HTMLElement {
  constructor() {
    super();
    this.toggleButton = this.querySelector('.custom-toggle');
    this.newArrivalFiler = document.querySelector('#Filter-buying-preferences--badge_new-arrival')
    this.updateActiveStateFromURL();
    this.initToggle();
    this.hideToggle();
  }

  initToggle() {
    if (!this.toggleButton) return;


    this.toggleButton.addEventListener("click", () => {
      this.toggleButton.classList.toggle("active");
    });
  }

  hideToggle() {
    if (this.newArrivalFiler.hasAttribute('disabled')) {
      this.classList.add('hidden')
    } else {
      this.classList.remove('hidden')
    }
  }

  // Method to check if the toggle is active
  isToggleActive() {
    return this.toggleButton.classList.contains("active");
  }

  updateActiveStateFromURL() {
    const currentUrl = window.location.href;

    // Check if this tag is in the URL
    if (currentUrl.includes('filter.p.tag=badge_new+arrival')) {
      this.toggleButton.classList.add("active");
    } else {
      this.toggleButton.classList.remove("active");
    }
  }
}

customElements.define('custom-tag-filter', customTagFilter);


// Custom sorting solution---------------------------------------------
class CollectionProductsFetcher {
  constructor() {
    this.container = document.getElementById('product-grid');
    this.options = JSON.parse(
      this.container.getAttribute("data-section-settings")
    );
    this.allProducts = [];
    this.productsPerPage = 50; // Shopify's fixed limit per page
    this.productCount = this.options.productCount; // Total products in collection
    this.sortBy = this.options.sortBy || null;
  }

  async fetchAllProducts() {
    const startTime = performance.now(); // Start timing

    try {
      const currentUrlParams = new URLSearchParams(window.location.search);
      const shouldFilterAvailability = getGridSetting("autoFilterAvailability");
      if (
        shouldFilterAvailability &&
        !currentUrlParams.has("filter.v.availability") &&
        !window.location.pathname.includes("/search")
      ) {
        currentUrlParams.set("filter.v.availability", "1");
      }
        
      const queries = [];
      let sortUrl = "";
      const paramsStr = currentUrlParams.toString();
      const view = `?view=json&${paramsStr ? paramsStr + '&' : ''}page=`;
      const numRequests = Math.ceil(this.productCount / this.productsPerPage);

      

      if (this.sortBy) {
        sortUrl = "&sort_by=" + this.sortBy;
      }

      // console.log(`Fetching ${numRequests} pages of products...`);

      for (let page = 1; page <= numRequests; page++) {
        const url = location.pathname + view +  page + sortUrl;
        // console.log(`Page ${page} URL:`, url);
        queries.push(fetch(url));
      }

      if (!queries.length) {
        console.error("Nothing to fetch!! Either you forgot to add .json template or the current page type doesn't have any products.");
        return;
      }

      const responses = await Promise.all(queries);
      const productsArrays = await Promise.all(
        responses.map(response => response.json())
      ); 
    
      
      for (let i = 0; i < productsArrays.length; i++) {
        const products = productsArrays[i];

        // console.log(`🔍 Page ${i + 1} - Total products: ${products.length}`);

        for (let j = 0; j < products.length; j++) {
          const product = products[j];

          // Log all products (before filtering)
          // console.log('📦 Fetched product:', product);

          this.allProducts.push(product);
          // if (product.available) {
          // } else {
          //   // console.log('❌ Skipped sold out product:', product.title);
          // }
        }
      }


      const endTime = performance.now(); // End timing
      const durationInSeconds = ((endTime - startTime) / 1000).toFixed(2);

      // console.log(`Total products fetched: ${this.allProducts.length}`);
      // console.log(`All Products:`, this.allProducts);
      // console.log(`⏱️ Fetched all products in ${durationInSeconds} seconds`);
      const configElement = document.getElementById('collection-sorting-config');
      console.log(configElement,'configElement');
      
      const activeSortBy = currentUrlParams.get('sort_by') || this.sortBy || 'manual';
      if (activeSortBy === 'manual' && configElement) {
        this.customSortProductsByPattern(configElement);
      }

      //show bestseller with tags 
      // if (currentUrlParams.get('sort_by') === 'best-selling' && configElement) {
      //   // Move products with 'Best_seller_test' tag to the top
      //   this.allProducts.sort((a, b) => {
      //     const aHasTag = a.tags && a.tags.includes("Best_seller_test");
      //     const bHasTag = b.tags && b.tags.includes("Best_seller_test");

      //     // Products with the tag come first
      //     if (aHasTag && !bHasTag) return -1;
      //     if (!aHasTag && bHasTag) return 1;
      //     return 0; // Leave relative order intact otherwise
      //   });

      //   console.log("Reordered products (Best_seller_test on top):", this.allProducts);
      // }

      console.log(this.allProducts,'all products');
      
      console.log(`⏱️ Fetched all products in ${durationInSeconds} seconds`);

      return this.allProducts;

    } catch (error) {
      console.error('Error fetching products:', error);
      return [];
    }
  }


customSortProductsByPattern(configElement) {
  console.log('sorting.......');

  let sortConfig = {};
  try {
    const parsed = JSON.parse(configElement.textContent);

    // Detect gender tags present in products
    const genderTags = ["Men", "Women", "Boys", "Girls"];
    const gendersFound = new Set();

    this.allProducts.forEach(product => {
      product.tags.forEach(tag => {
        if (genderTags.includes(tag)) {
          gendersFound.add(tag);
        }
      });
    });

    // Decide index based on gender tags found
    let index = 0;
    if (Array.isArray(parsed) && parsed.length > 1) {
      if (gendersFound.size === 1) {
        index = 1; // Only one gender → use second config
      } else {
        index = 0; // Multiple genders or none → use first config
      }
    }

    sortConfig = Array.isArray(parsed) ? parsed[index] : parsed;
  } catch (e) {
    console.error('Invalid JSON in collection sorting config:', e);
    return;
  }

  console.log(sortConfig, 'sortConfig');
  const tagOrder = Object.keys(sortConfig);
  if (!tagOrder.length) return;

  // Step 1: Group products by matching tag
  const tagGroups = {};
  tagOrder.forEach(tag => {
    tagGroups[tag] = [];
  });

  const unmatchedProducts = [];

  this.allProducts.forEach(product => {
    const matchingTag = tagOrder.find(tag =>
      product.tags.some(t => t.toLowerCase() === tag.toLowerCase())
    );

    // Ensure numeric values exist
    product.price = parseFloat(product.price || 0);
    product.inventory = parseInt(product.inventory || 0);

    if (matchingTag) {
      tagGroups[matchingTag].push(product);
    } else {
      unmatchedProducts.push(product); // fallback bucket
    }
  });

  // Step 2: Sort each group based on sortConfig
  for (const tag of tagOrder) {
    const group = tagGroups[tag];
    const rule = sortConfig[tag];
    if (!group) continue;

    if (rule === 'price_low_to_high') {
      group.sort((a, b) => a.price - b.price);
    } else if (rule === 'price_high_to_low') {
      group.sort((a, b) => b.price - a.price);
    } else if (rule === 'inventory_low_to_high') {
      group.sort((a, b) => a.inventory - b.inventory);
    } else if (rule === 'inventory_high_to_low') {
      group.sort((a, b) => b.inventory - a.inventory);
    } else if (rule === 'size_low_to_high') {
      group.sort((a, b) => a.availableVariants - b.availableVariants);
    } else if (rule === 'size_high_to_low') {
      group.sort((a, b) => b.availableVariants - a.availableVariants);
    } else if (rule === 'discount_low_to_high') {
      group.sort((a, b) => a.discountPercentage - b.discountPercentage);
    } else if (rule === 'discount_high_to_low') {
      group.sort((a, b) => b.discountPercentage - a.discountPercentage);
    }
  }

  // Step 3: Interleave the sorted groups
  const finalSorted = [];
  let exhausted = false;
  let index = 0;

  while (!exhausted) {
    exhausted = true;
    for (const tag of tagOrder) {
      const product = tagGroups[tag][index];
      if (product) {
        finalSorted.push(product);
        exhausted = false;
      }
    }
    index++;
  }

  // Step 4: Append unmatched products at the end
  finalSorted.push(...unmatchedProducts);

  // Update allProducts with the new sorted array
  this.allProducts = finalSorted;
}


  renderInitialProducts(products) {
    if (!this.container) {
      console.error('Product grid container not found!');
      return;
    }

    this.loadIndex = 12; // Track how many have been rendered

    // console.log(products.slice(0, this.loadIndex),'initial products');

    const productsHTML = products.slice(0, this.loadIndex)
      .map(p => `<li class="column">${p.cardHTML}</li>`)
      .join('');

    let grid = document.getElementById('product-grid');

    grid.innerHTML = productsHTML;
    // console.log(`🟢 Initially rendered 10 products.`);
  }


  renderNextProducts(products) {
    if (!this.container) {
      console.error('Product grid container not found!');
      return;
    }

    const start = this.loadIndex;
    const end = Math.min(start + 12, products.length);

    // console.log(produc:ts.slice(start, end),'next products');
    
    

    const nextBatchHTML = products.slice(start, end)
      .map(p => `<li class="column">${p.cardHTML}</li>`)
      .join('');

    let grid = document.getElementById('product-grid');


    grid.insertAdjacentHTML('beforeend', nextBatchHTML);

    // console.log(`➕ Appended products ${start + 1} to ${end}`);
    this.loadIndex = end;

    if (this.loadIndex >= products.length && this.observer) {
      // console.log("✅ All products rendered. Disconnecting observer.");
      this.observer.disconnect();
    }
  }


  getAllProducts() {
    return this.allProducts;
  }

  setupObserver(callback) {
    const trigger = document.getElementById('load-more-trigger');
    if (!trigger) {
      console.warn("⚠️ #load-more-trigger not found.");
      return;
    }

    this.observer = new IntersectionObserver((entries) => {
      const entry = entries[0];

      if (entry.isIntersecting) {
        // console.log("👀 Trigger is in view — calling callback.");
        callback(); // You handle what happens (e.g., inject HTML)
      }
    }, {
      rootMargin: '200px'
    });

    this.observer.observe(trigger);
  }


}

// Usage - Load products on initial collection page visit
function initCollectionProducts() {
  const grid = document.getElementById('product-grid');
  if (grid && !window.location.href.includes('/search')) {
    applyInitialCollectionUrlSettings();

    const fetcher = new CollectionProductsFetcher();
    window.collectionProductsFetcher = fetcher;
    fetcher.fetchAllProducts().then((products) => {
      fetcher.setupObserver(() => {
        fetcher.renderNextProducts(products);
      });
      fetcher.renderInitialProducts(products);
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollectionProducts);
} else {
  initCollectionProducts();
}

// Support live preview updates in Shopify Theme Customizer
document.addEventListener('shopify:section:load', (event) => {
  if (event.target && (event.target.querySelector('#product-grid') || event.target.id === 'shopify-section-main-collection-product-grid')) {
    applyInitialCollectionUrlSettings();
    initCollectionProducts();
  }
});
// pageshow event to handle search input box clear
window.addEventListener('pageshow', () => {
  const allInputs = document.querySelectorAll('input.facets-filter-searchbox');
  
  allInputs.forEach((input) => {
    input.value = '';
  });
});

